<template>
    <div id="page-content-wrapper" class="admin-content-area ops-calendar">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <!-- <div class="page-name">{{pageTitle}}</div> -->
            </div>
            <div class="admin-page-content">
                <div class="forms-container add_user_forms_container">
                    <div class="row no-margin">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 b-25 calendar-main-section">
                            <label class="nopermission">You don't have permission to access this page.</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <app-footer></app-footer>
    </div>
</template>

<script>
    import Footer from '@/components/partials/Footer';
    
    export default {
        components: {
            'app-footer': Footer,
        },
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/NoAccessPermission.vue